module.exports = __webpack_public_path__ + "static/slc-1ef6238b820a6242854a879a08c5be43.png";